import { SET_NOT_SENDED_QUERY_PLUGINS, SET_NOT_SENDED_QUERY_PLUGINS_DESCRIPTION, SET_NOT_SENDED_QUERY_PLUGINS_TABLE_OR_PIVOT } from "./NotSendedQueryPluginsAction";

/**
 *
 * @param {*} state
 * @param {*} action
 * Reducer for not sended query plugins
 *
 */
export default function NotSendedQueryPluginsReducer(
    state = {
        notSendedQueryPlugins: new Set(),
        notSendedQueryTableOrPivot: new Set(),
        notSendedQueryPluginDescription: ""
    },
    action
) {
    switch (action.type) {
        case SET_NOT_SENDED_QUERY_PLUGINS:
            return {
                ...state,
                notSendedQueryPlugins: action.payload
            };
        case SET_NOT_SENDED_QUERY_PLUGINS_DESCRIPTION:
            return {
                ...state,
                notSendedQueryPluginDescription: action.payload
            };
        case SET_NOT_SENDED_QUERY_PLUGINS_TABLE_OR_PIVOT:
            return {
                ...state,
                notSendedQueryTableOrPivot: action.payload
            };
        default:
            return state;
    }
}
